export const routeNames = {
  home: '/',
  blogs: '/blogs',
  blog: '/blog/:id',
  blog_: '/blog/',
};
